import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";

export const setSameEngineeredSFOnSameSpdrOrPdsrOnLtlPipeline = (
  project: ProjectViewModel,
  spdrOrPdsrId: number,
  sf: number
) => {
  return project.ltlPipelines?.map((ltlPipeline) => {
    if (ltlPipeline.SpdrId !== spdrOrPdsrId && ltlPipeline.PdsrId !== spdrOrPdsrId) {
      return ltlPipeline;
    }

    return {
      ...ltlPipeline,
      SupplierShipFrequency: sf,
    };
  });
};
